
import * as React from "react"
import * as Collapsible from "@radix-ui/react-collapsible"
import { ChevronRight } from "lucide-react"
import { cn } from "@/lib/utils"

const SidebarCollapsible = Collapsible.Root

const SidebarCollapsibleTrigger = React.forwardRef<
  React.ElementRef<typeof Collapsible.Trigger>,
  React.ComponentPropsWithoutRef<typeof Collapsible.Trigger>
>(({ className, children, ...props }, ref) => {
  return (
    <Collapsible.Trigger
      ref={ref}
      className={cn(
        "flex items-center justify-between w-full h-10 px-3 rounded-md hover:bg-accent hover:text-accent-foreground [&[data-state=open]>svg]:rotate-90",
        className
      )}
      {...props}
    >
      {children}
      <ChevronRight className="w-4 h-4 transition-transform duration-200 shrink-0" />
    </Collapsible.Trigger>
  )
})
SidebarCollapsibleTrigger.displayName = Collapsible.Trigger.displayName

const SidebarCollapsibleContent = React.forwardRef<
  React.ElementRef<typeof Collapsible.Content>,
  React.ComponentPropsWithoutRef<typeof Collapsible.Content>
>(({ className, children, ...props }, ref) => {
  return (
    <Collapsible.Content
      ref={ref}
      className={cn("pl-6 pt-2 pb-1", className)}
      {...props}
    >
      {children}
    </Collapsible.Content>
  )
})
SidebarCollapsibleContent.displayName = Collapsible.Content.displayName

export { SidebarCollapsible, SidebarCollapsibleTrigger, SidebarCollapsibleContent }
